export const API_URL = import.meta.env.VITE_FLATSY_API_ROOT
export const buildUrl = (path: string): string => `${API_URL || ''}${path}`
